import { EventEmitter, Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class PageLoaderService {
  constructor() { }

  isPageLoading = new BehaviorSubject<boolean>(false);
  public PageLoading: EventEmitter<boolean> = new EventEmitter();
  public count: number = 0;

  public showPageLoader(): void {

    this.PageLoading.emit(true);
  }

  public hidePageLoader(): void {
    this.PageLoading.emit(false);
  }

  public addPageLoader(): void {
    this.count++;
    this.PageLoading.emit(true);
    this.isPageLoading.next(true);
  }

  public takePageLoader(): void {
    if (this.count > 0) {
      this.count--;
    }
    if (this.count === 0) {
      this.PageLoading.emit(false);
      this.isPageLoading.next(false);
    }
  }
}
